<script lang="ts">
  import { type StoresKey } from "~/stores";
  import SvgMapApp from './SvgMapApp.svelte';

  // Keep the same props interface for backward compatibility
  export let request_store_key: StoresKey;
  export let config: any = {}; // Optional config, maintain for backward compatibility
  
  // Extract specific props that need to be passed separately
  let initialStoreId: string | null = config.initialStoreId || null;
  let autoZoomToStore: boolean = config.autoZoomToStore || false;
</script>

<!-- Simply wrap SvgMapApp component -->
<div class="svg-map-wrapper">
  <SvgMapApp 
    {request_store_key} 
    {initialStoreId} 
    {autoZoomToStore}
    mapConfig={config}
  />
</div>

<style>
  .svg-map-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 1;
  }
</style> 